"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RegistrationConstants = undefined;

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationConstants = exports.RegistrationConstants = (0, _keymirror2.default)({
    REGISTRATION_FORM_REQUEST: null,
    REGISTRATION_FORM_SUCCESS: null,
    REGISTRATION_FORM_FAIL: null,

    REGISTRATION_CONFIRM_REQUEST: null,
    REGISTRATION_CONFIRM_SUCCESS: null,
    REGISTRATION_CONFIRM_FAIL: null,

    REGISTRATION_RESET_STEP: null,

    REGISTRATION_VOICE_FORM_REQUEST: null,
    REGISTRATION_VOICE_FORM_SUCCESS: null,
    REGISTRATION_VOICE_FORM_FAIL: null,
    REGISTRATION_VOICE_RESET: null,

    REGISTRATION_RESET_ERROR: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/registration.js
// module id = 1879
// module chunks = 0